import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {CouponChargingResultVo} from '../../common/shared/api/nicolas/vo/SalesTicketVo.interface';

/**
 * 이용권 충전 내역 조회
 *
 * Origin: pageNicolasApi.getCouponChargingHistory
 * API: POST /api/v1/store/coupon_history/buy
 */
export async function postStoreCouponHistoryBuy(
  params?: {
    page?: number;
    freeOnly?: boolean;
  },
  options?: FetcherOptions
): Promise<CouponChargingResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/store/coupon_history/buy',
    {
      method: 'POST',
      data: {
        page: params?.page,
        free_only: params?.freeOnly,
      },
    },
    options
  );
  return response.data;
}
